<div (drop)="onDropFiles($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  class="bitf-dnd-droppable-area"
  [class.bitf-dnd-file-is-dragging]="isDragging">
  <ng-content></ng-content>
</div>